<template>
    <div class="home-warp container">
        <el-card class="box-card">
            <img v-if="!alreadySignUp" width="100%" :src="'/static/image/bmq.jpg'">
            <div style="text-align: center; margin-bottom: 10px">
                <el-button v-if="!alreadySignUp" type="primary" style="background-color: #e4552a;border-color: #e4552a;" @click="signUp">立即报名</el-button>
            </div>
            <img v-if="alreadySignUp" width="100%" :src="'/static/image/bmh.jpg'">
            <div id="poster" v-show="!base64url" style="font-size: 0">
                <img width="100%" :src="bgUrl">
                <el-row style="background-color: #e4552a; font-size: small;padding: 20px 0px" >
                    <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12" style="  display: flex;justify-content: center;align-items: center;">
                        <div style="text-align: center">
                            <vue-qr text="https://work.weixin.qq.com/u/vcdda3c89f9ffdd9b6?v=4.0.20.20360"  :size="80" :whiteMargin="true"  :margin="3"></vue-qr>
                            <p style="color: white">CSA Training</p>
                        </div>
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12" style=" display: flex;justify-content: center;align-items: center;">
                        <div style="text-align: center" v-if="qrcodeText">
                            <vue-qr :text="qrcodeText" :size="80" :callback="cb2" :whiteMargin="true" :margin="3" ></vue-qr>
                            <p style="color: white">活动报名</p>
                        </div>
                    </el-col>
                </el-row>
            </div>
            <img v-show="base64url" width="100%" :src="base64url">
        </el-card>
        <el-dialog title="登录" :visible.sync="toLogin" class="login-content">
            <v-login :currentName="loginActiveName" :closeDialogLogin="!toLogin" ></v-login>
        </el-dialog>
    </div>
</template>
<script>
import login from "./login.vue";
import VueQr from 'vue-qr'
import html2canvas from "html2canvas";

export default {
    components: {
        VueQr,
        "v-login": login
    },
    data: () => {
      return {
            isLogin: false,
            toLogin: false,
            loginActiveName: "login",
            alreadySignUp: false,
            bgUrl: null,
            introduction: null,
            base64url: null,
            qrcodeText: null,
            id1:0,
            id2:0,
        };
    },
    computed: {
        userInfo: function() {
            return this.$store.state.userInfo;
        }
    },

    created() {
        const myUserInfo = sessionStorage.getItem("userInfo");
        console.log("user",myUserInfo)
        this.getData()
    },
    mounted() {
    },
    methods: {
        async getData() {
            let loginRes = await  this.$axios.get("/user/getCurrentUser").catch(err => {return {}});
            // console.log(loginRes);
            const myUserInfo = loginRes.code === 200 ? loginRes.data: null;
            if (myUserInfo) {
                this.isLogin = true
            }

            if (this.isLogin) {
                let activityId = this.$route.query.activityId
                this.qrcodeText = `https://exam.c-csa.cn/#/activityImprovement?activityId=${activityId}&sourceUserId=${myUserInfo.id}`

                let res = await this.$axios.get(`/activity/getEvent?activityId=${activityId}&userId=${myUserInfo.id}&eventName=SIGNUP`);
                this.alreadySignUp = (res.code === 200 && res.data !== null && res.data.id !== null)
                if (this.alreadySignUp && sessionStorage.getItem("autoSignup")) {
                    this.$message.success("已报名成功，无需重复报名")
                    sessionStorage.removeItem("autoSignup")
                }
                if (!this.alreadySignUp && sessionStorage.getItem("autoSignup")) {
                    await this.signUp()
                    sessionStorage.removeItem("autoSignup");
                }
            }

            let activityId = this.$route.query.activityId
            let res = await this.$axios.get(`/activity/getById/${activityId}`);
            if (res.code === 200 && res.data !== null) {
                this.introduction = res.data.introduction;
                this.bgUrl = res.data.pictureUrl;
                let img = new Image()
                img.src = res.data.pictureUrl;
                img.onload = () => {
                    this.bgUrl = img.src;
                    this.cb1()
                }
            } else {
                this.$message.error("活动不存在")
            }
        },

        async signUp() {
            if (this.isLogin) {
                let res = await this.$axios.post("/activity/newEvent", {
                    activityId: this.$route.query.activityId,
                    sourceUserId: this.$route.query.sourceUserId,
                    userId: this.userInfo.id,
                    eventName: 'SIGNUP'
                });
                if (res.code === 200) {
                    this.alreadySignUp = true
                    this.$confirm("报名成功")
                }
            } else {
                sessionStorage.setItem("autoSignup", "true");
                this.toLogin=true
            }
        },

        cb1() {
            this.id1 = this.id1+1
            this.cb()
        },
        cb2(d) {
            this.id2 = this.id2+1
            this.cb()
        },
        cb() {
            console.log(this.id1,this.id2)
            if (this.id1 ===1 && this.id2 === 1) {
                setTimeout(() => {
                  this.createPoster()
                }, 0);
            }
        },
        async createPoster() {
            console.log('createPoster')
            let shareContent = document.getElementById('poster');//需要截图的包裹的（原生的）DOM 对象
            let width = shareContent.offsetWidth; //获取dom 宽度
            let height = shareContent.offsetHeight; //获取dom 高度
            let canvas = document.createElement("canvas"); //创建一个canvas节点
            let scale =  1; //定义任意放大倍数 支持小数
            canvas.width = width*scale ; //定义canvas 宽度 * 缩放
            canvas.height = height*scale; //定义canvas高度 *缩放
            canvas.style.width = width + "px";
            canvas.style.height = height + "px";
            canvas.getContext("2d").scale(scale,scale); //获取context,设置scale
            let opts = {
                scale: scale , // 添加的scale 参数
                useCORS: true,
                canvas:canvas, //自定义 canvas
                logging: true, //日志开关
            };

            console.log(width,height)
            canvas = await html2canvas(shareContent, opts);
            this.base64url = canvas.toDataURL("image/png");
        }
    },
    updated() {

    },

    filters: {}
};
</script>
<style>
.container {
    margin-left: auto;
    margin-right: auto;
    max-width: 960px;
}
.loading {
  min-height: 250px;
  line-height: 250px;
  color: #1564a7;
  text-align: center;
}
.el-icon-loading{
  font-size: 60px;
}
</style>

<style scoped>
.title {
  line-height: 60px;
}
.tips {
  /* color: #f56c6c; */
  font-size:14px;
  text-indent: 2em;
}
.home-warp {
  margin-top: 10px;
}
.el-carousel {
  width: 100%;
}
.el-carousel img {
  width: 100%;
}
.downLoad {
  cursor: pointer;
}
.remark {
  text-indent: 2em;
  line-height: 30px;
}
.exam-course {
  margin: 20px 10px;
}

.el-card {
  /* margin: 0 10px; */
}
.box-card {
  width: 100%;
  margin-top: 20px;
}

.time {
  font-size: 13px;
  color: #999;
}

.imgbox {
  /* max-height: 200px; */
  /* overflow: hidden; */
}
.imgbox img {
  width: 100%;
  cursor: pointer;
}
@media screen and (max-width: 767px) {
  .time,
  .el-table {
    font-size: 12px;
  }
  span {
    font-size: 14px;
  }
  .box-card {
    margin-top: 10px;
  }
  .home-warp {
    overflow: hidden;
    margin-top: 0;
  }

  /deep/.login-content .el-dialog {
    max-width: 450px;
    width: 100% !important;
  }

  /deep/.login-content .login-card {
    width: calc(100% - 80px) !important;
  }
}
</style>
